import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const PostDeploymentModuleSchema = z.object({
  postDeploymentModuleValue: z.instanceof(HexNumber),
})

type PostDeploymentModuleProps = z.infer<typeof PostDeploymentModuleSchema>

export class PostDeploymentModule extends ValueObject<PostDeploymentModuleProps> {
  public getValue(): HexNumber {
    return this.props.postDeploymentModuleValue
  }

  public static create(props: PostDeploymentModuleProps): PostDeploymentModule {
    const validatedProps = PostDeploymentModuleSchema.parse(props)
    return new PostDeploymentModule(validatedProps)
  }
}
